import { render, staticRenderFns } from "./sales-edit.vue?vue&type=template&id=7edca4d2&scoped=true&"
import script from "./sales-edit.vue?vue&type=script&lang=js&"
export * from "./sales-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edca4d2",
  null
  
)

export default component.exports